import { Component } from 'react';
import { AlertTriangle, RotateCcw } from 'lucide-react';

/** Keeps one broken screen from taking the whole app down in production. */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Page crashed:', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-6" data-testid="page-error-boundary">
        <div className="max-w-md w-full rounded-2xl border border-rose-500/30 bg-rose-500/5 p-6 text-center space-y-3">
          <AlertTriangle className="mx-auto text-rose-500" size={28}/>
          <h2 className="text-lg font-semibold">This screen hit a problem</h2>
          <p className="text-sm text-muted-foreground">
            The rest of the app is fine — reload this page to try again. If it keeps happening, tell us what
            you were doing and we will fix it.
          </p>
          <p className="text-xs font-mono text-muted-foreground break-words">{String(this.state.error?.message || '')}</p>
          <button
            onClick={() => window.location.reload()}
            className="inline-flex items-center gap-1.5 rounded-full bg-foreground text-background px-4 py-2 text-sm font-semibold"
            data-testid="page-error-reload"
          >
            <RotateCcw size={14}/>Reload
          </button>
        </div>
      </div>
    );
  }
}
